import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js"
        }}>{`// This works almost exactly like \`identify\` but for groups instead
// All future events from this session will be associated with this group
posthog.group('chat', '84359520')

posthog.capture('Message sent')
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    'distinct_id',
    'Message sent',
    groups={'chat': '84359520'}
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`posthog.capture({
    event: 'Message sent',
    distinctId: 'distinct_id',
    groups: { chat: '84359520' },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
    DistinctId: "distinct_id",
    Event: "Message sent",
    Groups: posthog.NewGroups().
        Set("chat", "84359520").
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
    'distinctId' => 'distinct_id',
    'event' => 'Message sent',
    '$groups' => array("chat" => "84359520")
));
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      